import { useEffect, useState } from "react";
import { useMarket } from "../lib/store";
import { fmt } from "../lib/format";
import { useFlashThrottle } from "./motion/hooks";

export function Price({ value, prev, className = "", testid, arrow = false }) {
  const [cls, setCls] = useState("");
  const [dir, setDir] = useState(0);
  const allow = useFlashThrottle(4);
  useEffect(() => {
    if (prev == null || value == null || prev === value) return undefined;
    const up = value > prev;
    setDir(up ? 1 : -1);
    if (!allow()) return undefined;
    setCls(up ? "flash-up" : "flash-down");
    const t = setTimeout(() => setCls(""), 400);
    return () => clearTimeout(t);
  }, [value, prev]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <span data-testid={testid} className={`num rounded-[3px] px-0.5 transition-colors duration-300 ${cls} ${className}`}>
      {fmt(value)}
      {arrow && dir !== 0 && <span className={`tick-arrow ${dir > 0 ? "text-up" : "text-down"}`}>{dir > 0 ? "▲" : "▼"}</span>}
    </span>
  );
}

export function ExTag({ ex, className = "" }) {
  if (!ex) return null;
  return <span className={`text-[9px] font-semibold tracking-wider text-muted-foreground border border-border rounded px-1 py-px ${className}`}>{ex}</span>;
}

export function StaleTag() {
  const h = useMarket((s) => s.status?.health);
  if (h !== "unavailable") return null;
  return <span data-testid="stale-price-tag" title="Live data unavailable — last known price" className="ml-1 text-[9px] font-mono font-bold uppercase tracking-wider text-down bg-down/10 border border-down/30 rounded px-1">STALE</span>;
}
